import React, { useState, useEffect } from 'react'
import { useNotifications } from '../../contexts/NotificationContext'
import { CampaignsProvider } from '../../contexts/CampaignsContext'
import AdsDashboard from './AdsDashboard'

const AdsSection = ({ currentUser, permissions }) => {
  const { showNotification } = useNotifications()
  const [activeTab, setActiveTab] = useState('dashboard')
  const [accounts, setAccounts] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadAccounts()
  }, [])

  const loadAccounts = async () => {
    try {
      setLoading(true)
      const userCells = currentUser?.cells?.join(',') || ''
      const response = await fetch(
        `/api/google-ads/accounts?userCells=${encodeURIComponent(userCells)}`
      )

      if (!response.ok) {
        throw new Error('Error al cargar cuentas de Google Ads')
      }

      const data = await response.json()
      setAccounts(data)
    } catch (error) {
      console.error('Error cargando cuentas:', error)
      showNotification('Error al cargar cuentas de Google Ads', 'error')
    } finally {
      setLoading(false)
    }
  }

  const handleAccountUpdate = () => {
    loadAccounts()
  }

  const tabs = [
    { id: 'dashboard', label: 'Dashboard', icon: '📊' },
    { id: 'alerts', label: 'Alertas', icon: '🔔' }
  ]

  if (loading) {
    return (
      <div className='flex justify-center items-center h-64'>
        <div className='animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600'></div>
      </div>
    )
  }

  return (
    <div className='space-y-6'>
      {/* Header */}
      <div className='bg-white rounded-lg shadow-sm p-6'>
        <div className='flex items-center justify-between'>
          <div>
            <h1 className='text-2xl font-bold text-gray-900'>
              🎯 Google & Meta Ads - Monitoreo y Alertas
            </h1>
            <p className='text-gray-600 mt-1'>
              Sistema completo de monitoreo para múltiples cuentas de Google & Meta Ads
            </p>
          </div>
          <div className='flex items-center space-x-4'>
            <div className='text-sm text-gray-500'>
              {accounts.length} cuenta{accounts.length !== 1 ? 's' : ''} configurada
              {accounts.length !== 1 ? 's' : ''}
            </div>
            <div className='flex items-center space-x-2'>
              <div className='w-3 h-3 bg-green-500 rounded-full animate-pulse'></div>
              <span className='text-sm text-green-600 font-medium'>En línea</span>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation Tabs */}
      <div className='bg-white rounded-lg shadow-sm'>
        <div className='border-b border-gray-200'>
          <nav className='flex space-x-8 px-6'>
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-200 ${
                  activeTab === tab.id
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <span className='mr-2'>{tab.icon}</span>
                {tab.label}
              </button>
            ))}
          </nav>
        </div>

        {/* Tab Content */}
        <div className='p-6'>
          {activeTab === 'dashboard' && (
            <CampaignsProvider>
              <AdsDashboard accounts={accounts} onRefresh={loadAccounts} />
            </CampaignsProvider>
          )}
        </div>
      </div>
    </div>
  )
}

export default AdsSection
